module.exports = __webpack_public_path__ + "img/connected.0464b463.gif";